



















































































import { Component, Prop, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import LaporanOperasiSvc from "@/services/LaporanOperasi";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";

@Component
export default class PemantauanAnestesiIdentitas extends Mixins(PrefillMixin) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  @Prop({ default: false }) readonly!: boolean;

  valid = false;
  menarikLapOp = false;

  form: any = {
    register_id: "",
    pasien_rm: "",
    diagnosa_pra_bedah: "",
    diagnosa_pra_bedah_icd10: "",
    jenis_pembedahan: "",
    operator_user_id: null,
    dokter_anestesi_user_id: null,
    penata_anestesi_user_id: null,
    pra_induksi_td_sistolik: null,
    pra_induksi_td_diastolik: null,
    pra_induksi_nadi: null,
    berat_badan: null,
    tinggi_badan: null,
    penyakit_penyerta: "",
    alergi: "",
    asma: false,
    // defaults for required fields on create
    agen_anestesi: { halothane: false, ether: false, isoflurane: false, sevoflurane: false, n2o: false, o2_persen: null, o2_lpm: null },
    jenis_anestesi: "general",
    asa_status: "2",
    mulai_anestesi_at: null,
  };

  get dokterList() {
    return storeDokter.listAll;
  }

  get perawatList() {
    return storePerawat.listPerawat;
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "pemantauan_anestesi";

  prefillResolvePath(path: string) {
    if (Object.prototype.hasOwnProperty.call(this.form, path)) {
      return {
        get: () => this.form[path],
        set: (v) => {
          this.form[path] = v;
        }
      };
    }
    return { get: () => "__skip__", set: () => undefined };
  }
  // ───────────────────────────────────────────────────────────────────

  mounted() {
    this.form.register_id = this.register;
    this.form.pasien_rm = this.rm;
    storeDokter.act_dokter_all();
    storePerawat.actListPerawatall();

    if (!this.editData && !this.readonly) {
      // Record baru: soft-prefill field kosong dari APB + TTV register ini.
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: String(this.rm),
          register_id: this.register
        });
      });
    }

    if (this.editData) {
      Object.keys(this.form).forEach(key => {
        if (this.editData[key] !== undefined) {
          this.form[key] = this.editData[key];
        }
      });
    }
  }

  get bmiDisplay() {
    if (!this.form.berat_badan || !this.form.tinggi_badan) return "-";
    const tbM = this.form.tinggi_badan / 100;
    const bmi = (this.form.berat_badan / (tbM * tbM)).toFixed(1);
    let kat = "Normal";
    if (parseFloat(bmi) < 18.5) kat = "Underweight";
    else if (parseFloat(bmi) >= 25 && parseFloat(bmi) < 30) kat = "Overweight";
    else if (parseFloat(bmi) >= 30) kat = "Obese";
    return `${bmi} (${kat})`;
  }

  async ambilDariLaporanOperasi() {
    if (this.readonly || this.menarikLapOp) return;
    this.menarikLapOp = true;
    try {
      const resp = await LaporanOperasiSvc.getByRegister(this.register);
      const list: any[] = (resp?.data as any) || [];
      if (!list.length) {
        appModule.sendErrorAlert("Belum ada Laporan Operasi pada kunjungan ini");
        return;
      }
      const lapop = list[list.length - 1];
      const dx = lapop.diag_pra || "";
      const tindakan = lapop.category_text || lapop.jenis_tindakan || "";
      if (!dx && !tindakan) {
        appModule.sendErrorAlert("Laporan Operasi belum mengisi diagnosa pra bedah");
        return;
      }
      if (dx) this.form.diagnosa_pra_bedah = dx;
      if (tindakan) this.form.jenis_pembedahan = tindakan;
      appModule.NoticeDelay("Diagnosa diambil dari Laporan Operasi");
    } catch {
      // handled by service
    } finally {
      this.menarikLapOp = false;
    }
  }

  validateStep(): boolean {
    return (this.$refs.form as any).validate();
  }

  collectPayload(): any {
    const {
      agen_anestesi,
      jenis_anestesi,
      asa_status,
      mulai_anestesi_at,
      ...identitas
    } = this.form;

    if (this.editData?.id) return identitas;

    return {
      ...identitas,
      agen_anestesi,
      jenis_anestesi,
      asa_status,
      mulai_anestesi_at
    };
  }

  markSaved() {
    // Identitas memegang state-nya sendiri (tidak reload dari prop),
    // jadi tidak ada yang perlu direset.
  }
}
